import React, { useEffect, useState } from "react";
import SalesReportService from "../../../services/OrderingServices/SalesReportService";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { Triangle } from "react-loader-spinner";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
// import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { formatDateTimes } from "../../../Components/Common/FormatDate";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import ItemService from "../../../services/OrderingServices/ItemService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const TransactionReport = () => {
  const { id } = useParams();
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  console.log("🚀 ~ TransactionReport ~ selectedCategory:", selectedCategory);
  const [productData, setProductData] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // Format helper
  const formatDate = (date) => date?.toLocaleDateString("en-CA");

  // Fetch product list
  const fetchItemList = async () => {
    try {
      setLoading(true);
      const response = await ItemService.itemList();
      setProductData(response?.items || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItemList();
  }, []);

  // Fetch transaction data
  const fetchData = async (
    from = fromDate,
    to = toDate,
    category = selectedCategory
  ) => {
    if (!from || !to) {
      alert("Please select both From and To dates");
      return;
    }

    setLoading(true);
    try {
      const response = await SalesReportService.getTransactionList({
        productId: category?.value || id,
        fromDate: formatDate(from),
        toDate: formatDate(to),
      });
      setAllData(response || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

  // Default: last 1 month on mount + auto-fetch
  useEffect(() => {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(today.getMonth() - 1);

    setFromDate(lastMonth);
    setToDate(today);

    fetchData(lastMonth, today, null);
  }, []);

  // Table columns
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Product",
      selector: (row) => (
        <span title={`${row?.productName}`} className="cursor-pointer">
          {row.productName}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      sortable: true,
      right: true,
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice,
      sortable: true,
      right: true,
    },
    {
      name: "Transaction Date",
      selector: (row) => formatDateTimes(row?.transactionDate),
      sortable: true,
      width: "14vw",
    },
    {
      name: "Debit",
      selector: (row) => row.debit,
      sortable: true,
      right: true,
    },
    {
      name: "Credit",
      selector: (row) => row.credit,
      sortable: true,
      right: true,
    },
    {
      name: "Total",
      selector: (row) => row.totalAmount,
      sortable: true,
      right: true,
    },
  ];

  const categoryOptions =
    productData?.map((item) => ({ value: item.id, label: item.name })) || [];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Transaction Log List" pageTitle="Transaction Log" />

        {/* Filters */}
        <Row className="mb-2 align-items-end">
          <Col md={3} className="mb-2">
            <Select
              isClearable
              options={categoryOptions}
              value={selectedCategory}
              onChange={setSelectedCategory}
              placeholder="Filter by product"
              className="fs-6"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </Col>
          <Col md={2} className="mb-2">
            <Flatpickr
              options={{ dateFormat: "Y-m-d" }}
              value={fromDate}
              onChange={(dates) => setFromDate(dates[0])}
              className="form-control"
              placeholder="From Date"
            />
          </Col>
          <Col md={2} className="mb-2">
            <Flatpickr
              options={{ dateFormat: "Y-m-d" }}
              value={toDate}
              onChange={(dates) => setToDate(dates[0])}
              className="form-control"
              placeholder="To Date"
            />
          </Col>
          <Col md={2} className="mb-2">
            <Button
              color="primary"
              className="w-100"
              onClick={() => fetchData()}
            >
              Generate
            </Button>
          </Col>
        </Row>

        {/* Table */}
        {loading ? (
          <div className="my-5 text-center d-flex flex-column align-items-center">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
            />
            <h5 className="mt-3">Loading...</h5>
          </div>
        ) : (
          <Card>
            <CardBody>
              <CustomDataTable
                responsive
                striped
                pagination
                fixedHeader
                persistTableHead
                progressPending={loading}
                columns={columns}
                data={allData}
              />
            </CardBody>
          </Card>
        )}
      </div>
    </div>
  );
};

export default TransactionReport;
